export function getStartDate(date: Date) {
  date.setHours(0, 0, 0, 0);
  return date.toISOString();
}

export function getEndDate(date: Date) {
  date.setHours(23, 59, 59, 999);
  return date.toISOString();
}
